import {
  FormFieldSchema,
  FormFieldType,
  TriggerCondition,
  TriggerType,
} from "@app/components/forms/types/schema";

import { PlatformType } from "@app/types/platform";

export const ShopSettingsSchema: FormFieldSchema[] = [
  {
    id: "shopBaseInfo",
    label: "기본 정보",
    description: "쇼핑몰의 기본 정보",
    noneStyle: true,
    type: FormFieldType.Group,
    schemas: [
      {
        id: "platformName",
        label: "쇼핑몰 상호명",
        placeholder: "상호명을 입력해주세요.",
        description: "쇼츠웍스와 연동된 쇼핑몰의 상호명입니다.",
        type: FormFieldType.Text,
        behavior: {
          required: true,
        },
      },
      {
        id: "shopNo",
        label: "샵번호",
        type: FormFieldType.Text,
        placeholder: "샵번호",
        description: "샵번호를 입력하세요.",
        behavior: {
          disabled: true,
          triggers: [
            {
              type: TriggerType.Show,
              field: "platformType",
              value: "cafe24",
              condition: TriggerCondition.Equal,
            },
          ],
        },
      },
      {
        id: "platformUrl",
        label: "쇼핑몰 URL",
        placeholder: "URL을 입력해주세요.",
        description: "쇼츠웍스와 연동된 쇼핑몰의 URL입니다.",
        type: FormFieldType.URL,
        behavior: {
          required: true,
        },
      },
      // 트리거로 사라져도 폼에 영향을 받음
      {
        id: 'platformId',
        label: '쇼핑몰 ID',
        placeholder: '쇼핑몰 ID를 입력해주세요.',
        type: FormFieldType.Text,
        behavior: {
          // required: true,
          triggers: [
              {
                type: TriggerType.Show,
                field: 'platformType',
                value: PlatformType.CAFE24,
                condition: TriggerCondition.Equal,
            },
            {
              type: TriggerType.Enable,
              field: 'platformType',
              value: PlatformType.FLEXG,
              condition: TriggerCondition.Equal,
            }
          ],
        },
      },
      {
        id: "platformType",
        label: "호스팅 플랫폼",
        placeholder: "Enter title",
        type: FormFieldType.Text,
        behavior: {
          required: true,
          disabled: true,
        },
      },
    ],
  },
  { type: FormFieldType.Separator },
  {
    type: FormFieldType.Group,
    id: "administrator",
    label: "관리자 정보",
    noneStyle: true,
    description: "쇼츠웍스 서비스 이용 관련 안내를 받게 될 관리자 정보입니다.",
    schemas: [
      {
        id: "name",
        label: "관리자 이름",
        placeholder: "Enter title",
        type: FormFieldType.Text,
        behavior: {
          required: true,
        },
      },
      {
        id: "email",
        label: "이메일",
        placeholder: "이메일을 입력해주세요.",
        type: FormFieldType.Email,
        behavior: {
          required: true,
        },
      },
    ],
  },
];
